module.exports = __webpack_public_path__ + "static/media/LLL.5971a687.png";